import Vue from 'vue'
import config from '@/pages.common'

new Vue({
  ...config,
  components: { 'Order': () => import ('@/components/Order') },
  render: h => h('Order'),
}).$mount('#AppOrder');
